<template>
  <div>
    <v-btn
      block
      color="green"
      @click="addCombination"
    >
      {{ $t('addCombination') }}
    </v-btn>
    <v-tabs-items v-model="selectedAppBarTab">
      <v-tab-item
        v-for="tab in tabs"
        :value="tab.key"
        :key="tab.key"
      >
        <ActionList
          v-if="locationVariationCombinations.length > 0"
          :preloaded-items-list="slicedLocationVariationCombinations(tab.key)"
        >
          <template v-slot:item="{ item, index }">
            <LocationVariationCombinationListItem
              :location-variation-combination="item"
              @select="selectVariationCombination"
            />
            <v-divider v-if="index < locationVariationCombinations.length - 1" />
          </template>
        </ActionList>
      </v-tab-item>
    </v-tabs-items>
    <v-dialog
      v-model="showVariationCombinationDialog"
      max-width="550px"
      @click:outside="closeVariationCombinationDialog"
    >
      <EditLocationVariationCombination
        :combination="selectedVariationCombination"
        :location="location"
        @close="closeVariationCombinationDialog"
      />
    </v-dialog>
  </div>
</template>

<script>
  import ActionList from "@/components/common/list/ActionList"
  import LocationVariationCombinationListItem from "@/components/location/LocationVariationCombinationListItem"
  import EditLocationVariationCombination from "@/components/location/EditLocationVariationCombination"

  export default {
    name: 'Combinations',
    components: {
      EditLocationVariationCombination,
      LocationVariationCombinationListItem,
      ActionList
    },
    props: ['location'],
    data: () => ({
      showVariationCombinationDialog: false,
      selectedVariationCombination: null
    }),
    methods: {
      addCombination() {
        this.selectVariationCombination(null)
      },
      selectVariationCombination(value) {
        this.selectedVariationCombination = value
        this.showVariationCombinationDialog = true
      },
      closeVariationCombinationDialog() {
        this.$store.dispatch('getLocationVariationCombinations')
        this.selectedVariationCombination = null
        this.showVariationCombinationDialog = false
      },
      slicedLocationVariationCombinations(state) {
        if(state === 'active') {
          return this.locationVariationCombinations.filter(c => c.active === true)
        } else {
          return this.locationVariationCombinations.filter(c => c.active !== true)
        }
      }
    },
    computed: {
      zones() {
        return this.$store.state.zones
      },
      variations() {
        if(this.location === null) {
          return []
        } else {
          return this.location.variations
        }
      },
      locationVariationCombinations() {
        return this.$store.state.locationVariationCombinations.filter(c => { return c.location.uuid === this.location.uuid })
      },
      selectedAppBarTab: function() {
        return this.$store.state.selectedAppBarTab
      },
      tabs() {
        return [
          {
            title: this.$t('active'),
            key: 'active',
            badge: {
              color: 'green',
              content: this.slicedLocationVariationCombinations('active').length
            }
          },
          {
            title: this.$t('inactive'),
            key: 'inactive',
            badge: {
              color: 'red',
              content: this.slicedLocationVariationCombinations('inactive').length
            }
          }
        ]
      }
    },
    beforeCreate() {
      this.$store.dispatch('getLocationVariationCombinations')
    },
    mounted() {
      this.$store.commit('updateAppBarTabs', this.tabs)

      if(this.tabs.length > 0) {
        this.$store.commit('updateSelectedAppBarTab', this.tabs[0].key)
      }
    }
  }
</script>

<style scoped>

</style>
